module.exports = __webpack_public_path__ + "static/media/gh-map-mobile-tc.1519b630.png";